export default __webpack_public_path__ + "static/media/border2r.bdf66b9e.png";